const SEARCH_ALL = (text) => `/api/app/overall-search/?search=${text}`;

export { SEARCH_ALL };
